const projectData = [
  {
    title: "Marvel Heroes",
    builtWith: ["react", "redux", "styled-component", "react-bootstrap-3"],
    info:
      "Info about Marvel heroes using Marvel API with React, Redux and Styled-Component.",
    codeLink: "https://github.com/marufMunshi/marvel-heroes",
    liveLink: "https://marvel-heroes-munshi.netlify.app",
  },
  {
    title: "Server Mold",
    builtWith: ["react", "react-router", "react-bootstrap-3"],
    info: "A hosting site made with React, React-Router and  React-Bootstrap.",
    codeLink: "https://github.com/marufMunshi/server-mold-react",
    liveLink: "hhttps://server-mold.netlify.app",
  },
  {
    title: "Personal Website",
    builtWith: ["react", "react-router", "material-ui", "styled-component"],
    info: "My personal website",
    codeLink: false,
    liveLink: "http://maruf.me/",
  },
  {
    title: "Markdown Previewer",
    builtWith: ["react", "marked-js"],
    info: "Markdown Editor with live preview.",
    codeLink: "https://github.com/marufMunshi/markdown-previewer",
    liveLink: "https://munshi-markdown-previewer.netlify.com",
  },
  {
    title: "Random Quote Machine",
    builtWith: ["react"],
    info: "Generate random quote with button click.",
    codeLink: "https://github.com/marufMunshi/quote-machine",
    liveLink: "https://munshi-quote-machine.netlify.com/",
  },
  {
    title: "Calculator",
    builtWith: ["react"],
    info: "A JavaScript calculator.",
    codeLink: "https://github.com/marufMunshi/react-calculator",
    liveLink: "https://munshi-calculator.netlify.com/",
  },
  {
    title: "Pomodoro Clock",
    builtWith: ["react"],
    info: "Timer clock using pomodoro technique.",
    codeLink: "https://github.com/marufMunshi/pomodoro-clock",
    liveLink: "https://munshi-pomodoro-clock.netlify.com/",
  },
  {
    title: "Drum Kit",
    builtWith: ["react"],
    info: "Press button or click to play various drum sound.",
    codeLink: "https://github.com/marufMunshi/drum-machine",
    liveLink: "https://munshi-drum-kit.netlify.com/",
  },
  {
    title: "Forkify JS",
    builtWith: ["javascript", "api", "course-project"],
    info: "Search food and show food recipe using API from Food2Fork.",
    codeLink: "https://github.com/marufMunshi/forkify-js-course",
    liveLink: "https://forkify-js-course.herokuapp.com/",
  },
  {
    title: "Pig Game",
    builtWith: ["javascript", "course-project"],
    info: "Pig game built with JavaScript(ES5).",
    codeLink: "https://github.com/marufMunshi/pig-game",
    liveLink: "https://marufmunshi.github.io/pig-game/",
  },
  {
    title: "Budgety",
    builtWith: ["javascript", "course-project"],
    info: "A simple budget app. Made with JavaScript(ES5).",
    codeLink: "https://github.com/marufMunshi/budgety",
    liveLink: "https://marufmunshi.github.io/budgety/",
  },
];

export default projectData;
